const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || 'https://redline-autohaus-api.herokuapp.com'
).replace(/\/+$/, '');

const buildApiUrl = (path) => {
  if (!path) {
    return API_BASE_URL;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (API_BASE_URL.endsWith('/api') && normalizedPath.startsWith('/api/')) {
    return `${API_BASE_URL}${normalizedPath.slice('/api'.length)}`;
  }

  return `${API_BASE_URL}${normalizedPath}`;
};

export { API_BASE_URL, buildApiUrl };
